import { useEffect, useState, useCallback } from "react";
import axios from "../customAxios.js";

const getInitialState = () => {
  const savedStateJSON = localStorage.getItem("adminsFilter");
  const defaults = {
    filters: { search: "" },
    pagination: { page: 1, rowsPerPage: 20 },
  };

  if (savedStateJSON) {
    try {
      const savedState = JSON.parse(savedStateJSON);
      return {
        filters: { ...defaults.filters, ...(savedState.filters || {}) },
        pagination: { ...defaults.pagination, ...(savedState.pagination || {}) },
      };
    } catch (error) {
      console.error(`Error obteniendo datos del localStorage "adminsFilter": ${error}`);
      return defaults;
    }
  }
  return defaults;
};

export function useAdmins() {
  const [initialState] = useState(() => getInitialState());
  const [filters, setFilters] = useState(initialState.filters);
  const [pagination, setPagination] = useState(initialState.pagination);
  const [auxSearcher, setAuxSearcher] = useState(filters.search);
  const [admins, setAdmins] = useState([]);
  const [adminsCount, setAdminsCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const handleFilterChange = useCallback((filterName, value) => {
    setFilters((prev) => ({ ...prev, [filterName]: value }));
    setPagination((prev) => ({ ...prev, page: 1 }));
  }, []);

  const handleChangePage = useCallback((newPage) => {
    setPagination((prev) => ({ ...prev, page: newPage }));
  }, []);

  const handleChangeRowsPerPage = useCallback((newRowsPerPage) => {
    setPagination({ page: 1, rowsPerPage: newRowsPerPage });
  }, []);

  const fetchAdmins = useCallback(async () => {
    setLoading(true);
    setError(null);
    const params = {
      search: filters.search || undefined,
      page: pagination.page,
      page_size: pagination.rowsPerPage,
    };

    try {
      const {
        data: { results: admins, count },
      } = await axios.get("admins/staff/list/", { params });
      setAdmins(admins);
      setAdminsCount(count);
    } catch (error) {
      console.error(`No se pudo obtener los admins: ${error}`);
      setError("No se pudo obtener los admins");
    } finally {
      setLoading(false);
    }
  }, [pagination, filters]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (auxSearcher !== filters.search) {
        handleFilterChange("search", auxSearcher);
      }
    }, 1500);
    return () => clearTimeout(timer);
  }, [auxSearcher, filters.search, handleFilterChange]);

  useEffect(() => {
    localStorage.setItem("adminsFilter", JSON.stringify({ filters, pagination }));
  }, [filters, pagination]);

  useEffect(() => {
    fetchAdmins();
  }, [fetchAdmins]);

  return {
    admins,
    adminsCount,
    loading,
    error,
    filters,
    pagination,
    auxSearcher,
    refetchAdmins: fetchAdmins,
    handleFilterChange,
    handleChangePage,
    handleChangeRowsPerPage,
    setAuxSearcher,
  };
}
